export default ({ store, redirect }) => {
  const { auth } = store.state
  if (auth.loggedIn && auth.user.finalized)
    return redirect('/area-riservata/dashboard')
}
